import {translater} from '../../tools/translate';

export const usernameRules = [
    v => !!v || translater.__("{0} is required", "userValidation", translater.__("Username", "users")),
    //v => v.length <= 10 || 'Name must be less than 10 characters'
];

export const passwordRules = [
    v => !!v || translater.__("{0} is required", "userValidation", translater.__("Password", "users"))
]

export const confirmationRules = (pw) => {

	return [ 
		v => !!v || translater.__("{0} is required", "userValidation", translater.__("Confirmation", "users")),
		v => v === pw || translater.__("Password and confirmation have to match", "userValidation")

	]
} 